
/* styles */
require("!!vue-style-loader!css-loader!./../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-521185fa&scoped=true!./../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./Purchase.vue")

var Component = require("/home/travis/build/tonyhhyip/library/node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel!./../../../node_modules/vue-loader/lib/selector?type=script&index=0!./Purchase.vue"),
  /* template */
  require("!!./../../../node_modules/vue-loader/lib/template-compiler?id=data-v-521185fa!./../../../node_modules/vue-loader/lib/selector?type=template&index=0!./Purchase.vue"),
  /* scopeId */
  "data-v-521185fa",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./assets/js/page/Purchase.vue
// module id = 63
// module chunks = 0